<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.statusId"
    item-text="statusNome"
    item-name="statusNome"
    item-value="statusId"
    :items="statusRelacionamento"
    :label="label"
    :hide-details="hideDetails"
    :solo="solo"
    :outlined="outlined"
    :dense="dense"
    :disabled="disabled"
    placeholder="Status"
    v-on:change="onChangeStatus"
    :clearable="true"
    :multiple="isMultiple ? true : false"
    :return-object="isMultiple ? true : false"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.statusNome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.statusId.length - maxDisplay }} status)</span
      >
    </template>
    <template slot="no-data">
      Nenhum Status de Relacionamento retornado
    </template>
    <template v-if="includeTodos && isMultiple" v-slot:prepend-item>
      <v-list-item ripple @click="selecionarTodos">
        <v-list-item-content>Todos</v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>
  </v-select>
</template>

<script>
import { StatusRelacionamentoApi } from "../API/StatusRelacionamentoApi.js";

export default {
  name: "AppStatusCombobox",
  props: {
    filter: { type: Object, required: true },
    isMultiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    solo: { type: Boolean, default: true },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    hideDetails: { type: [Boolean, String], default: "auto" },
    label: { type: String, default: "Status" },
    includeElegivelIan: { type: Boolean, default: false },
    includeTodos: { type: Boolean, default: false },
    statusNomesPermitidos: { type: Array, default: null },
  },
  mounted() {
    this.loadStatus();
  },
  methods: {
    loadStatus() {
      StatusRelacionamentoApi.list()
        .then((resp) => {
          let statusRelacionamento = resp.data || [];

          if (Array.isArray(this.statusNomesPermitidos)) {
            const permitidos = this.statusNomesPermitidos.map((nome) =>
              this.normalizarNome(nome)
            );
            statusRelacionamento = statusRelacionamento.filter((status) =>
              permitidos.includes(this.normalizarNome(status.statusNome))
            );
          }

          if (
            this.includeElegivelIan &&
            !statusRelacionamento.some((status) =>
              this.isElegivelIanStatus(status)
            )
          ) {
            statusRelacionamento.push({
              statusId: "elegivelIan",
              statusNome: "Elegível IAN",
            });
          }

          this.statusRelacionamento = statusRelacionamento;
        })
        .catch();
    },
    onChangeStatus(value) {
      if (
        this.isMultiple &&
        Array.isArray(value) &&
        value.length === this.statusRelacionamento.length
      ) {
        value = [];
        this.filter.statusId = [];
      }
      const selectedStatus = this.isMultiple
        ? value
        : this.statusRelacionamento.find((status) => status.statusId === value);

      this.$emit("onChange", value, selectedStatus || null);
    },
    selecionarTodos() {
      this.filter.statusId = [];
      this.$emit("onChange", [], null);
    },
    normalizarNome(nome) {
      return (nome || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]/gi, "")
        .toLowerCase();
    },
    isElegivelIanStatus(status) {
      const statusName = status && status.statusNome;

      return (
        statusName &&
        statusName
          .toString()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase() === "elegivel ian"
      );
    },
  },
  data() {
    return {
      statusRelacionamento: [],
      maxDisplay: 1,
    };
  },
};
</script>
